import React from 'react';
import { ROUTES } from './routes';

export interface DealRow {
  name: string;
  type: string;
  adminEmail: string;
  status: 'Active' | 'Inactive';
  country: string;
  userLimit: number;
  registeredUsers: number;
  expirationDate: string;
}

export interface DistrictRow {
  id: string;
  district: string;
  admin: string;
  adminEmail: string;
  schools: number;
  users?: number;
  contact?: string;
}

export interface SchoolRow {
  name: string;
  teachers: number;
  students: number;
  contact: string;
}

export interface School {
  name: string;
  type: string;
  status: string;
  admin: string;
  adminEmail: string;
  registeredUsers: number;
  activeUsers: number;
}

export type DealInfo = {
  label: string;
  value: string | number;
  isBold?: boolean;
  isRed?: boolean;
  note?: string;
  isLink?: boolean;
  linkText?: string;
  linkHref?: string;
  hint?: React.ReactNode;
};

// Exact data from the provided image
export const dealsTableData: DealRow[] = [
  {
    name: 'Nofar Halpern',
    type: 'Product Demo',
    adminEmail: 'Nofarh@melingo.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 55000,
    registeredUsers: 485,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Admin User',
    type: 'Product Demo',
    adminEmail: 'admin@company.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 55000,
    registeredUsers: 485,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Jane Smith',
    type: 'Product Demo',
    adminEmail: 'jane.smith@company.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 55000,
    registeredUsers: 485,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Craigie',
    type: 'Customer Trial',
    adminEmail: 'Biatreas@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 12300,
    registeredUsers: 100,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Whitfield',
    type: 'Customer Pilot',
    adminEmail: 'binhan628@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 10500,
    registeredUsers: 4000,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'West End',
    type: 'Test',
    adminEmail: 'tranthuy.nute@gmail.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 2340,
    registeredUsers: 7000,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Stobswell',
    type: 'Customer Pilot',
    adminEmail: 'tienlapspktnd@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 10500,
    registeredUsers: 3000,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Coldside',
    type: 'Customer Subscription',
    adminEmail: 'nvt.lisst.nute@gmail.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 10500,
    registeredUsers: 800,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Ardler',
    type: 'Customer Trial',
    adminEmail: 'ckctml2@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 9000,
    registeredUsers: 500,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Lochee',
    type: 'Customer Pilot',
    adminEmail: 'vuhaithuongnute@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 9000,
    registeredUsers: 6750,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'City Centre',
    type: 'Product Demo',
    adminEmail: 'thuhang.nute@gmail.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 55000,
    registeredUsers: 485,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Downfield',
    type: 'Test',
    adminEmail: 'danghoang87h1@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 45000,
    registeredUsers: 230,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Fintry',
    type: 'Product Demo',
    adminEmail: 'manhhachtk08@gmail.com',
    status: 'Active',
    country: 'Brazil',
    userLimit: 16000,
    registeredUsers: 10000,
    expirationDate: '2025-Jan-12',
  },
  {
    name: 'Hilltown',
    type: 'Product Demo',
    adminEmail: 'trungkienpsktnd@gmail.com',
    status: 'Inactive',
    country: 'Brazil',
    userLimit: 55000,
    registeredUsers: 485,
    expirationDate: '2025-Jan-12',
  },
];

export const districts: DistrictRow[] = [
  {
    id: 'district-1',
    district: 'Pacific Northwest',
    admin: 'Courtney Henry',
    adminEmail: 'courtney.henry@example.com',
    schools: 1,
    users: 429,
    contact: 'Courtney Henry',
  },
  {
    id: 'district-2',
    district: 'California',
    admin: 'Annette Black',
    adminEmail: 'annette.black@example.com',
    schools: 2,
    users: 798,
    contact: 'Annette Black',
  },
  {
    id: 'district-3',
    district: 'Great Plains',
    admin: 'Arlene McCoy',
    adminEmail: 'arlene.mccoy@example.com',
    schools: 30,
    users: 453,
    contact: 'Arlene McCoy',
  },
  {
    id: 'district-4',
    district: 'California',
    admin: 'Leslie Alexander',
    adminEmail: 'leslie.alexander@example.com',
    schools: 4,
    users: 130,
    contact: 'Leslie Alexander',
  },
  {
    id: 'district-5',
    district: 'South Central',
    admin: 'Savannah Nguyen',
    adminEmail: 'savannah.nguyen@example.com',
    schools: 7,
    users: 816,
    contact: 'Savannah Nguyen',
  },
  {
    id: 'district-6',
    district: 'Midwest',
    admin: 'Theresa Webb',
    adminEmail: 'theresa.webb@example.com',
    schools: 1,
    users: 177,
    contact: 'Theresa Webb',
  },
  {
    id: 'district-7',
    district: 'Mountain',
    admin: 'Eleanor Pena',
    adminEmail: 'eleanor.pena@example.com',
    schools: 9,
    users: 274,
    contact: 'Eleanor Pena',
  },
  {
    id: 'district-8',
    district: 'Pacific Island',
    admin: 'Ralph Edwards',
    adminEmail: 'ralph.edwards@example.com',
    schools: 1,
    users: 740,
    contact: 'Ralph Edwards',
  },
  {
    id: 'district-9',
    district: 'Great Plains',
    admin: 'Kathryn Murphy',
    adminEmail: 'kathryn.murphy@example.com',
    schools: 34,
    users: 738,
    contact: 'Kathryn Murphy',
  },
  {
    id: 'district-10',
    district: 'Northeast',
    admin: 'Jacob Jones',
    adminEmail: 'jacob.jones@example.com',
    schools: 56,
    users: 583,
    contact: 'Jacob Jones',
  },
  {
    id: 'district-11',
    district: 'Mid-Atlantic',
    admin: 'Guy Hawkins',
    adminEmail: 'guy.hawkins@example.com',
    schools: 1,
    users: 196,
    contact: 'Guy Hawkins',
  },
  {
    id: 'district-12',
    district: 'Southeast',
    admin: 'Cameron Williamson',
    adminEmail: 'cameron.williamson@example.com',
    schools: 56,
    users: 492,
    contact: 'Cameron Williamson',
  },
];

export const schools: SchoolRow[] = [
  {
    name: 'Pacific Northwest',
    teachers: 1,
    students: 429,
    contact: 'Courtney Henry',
  },
  // Add more rows as needed
];

export const schoolsTableData: School[] = [
  {
    name: 'Cragmont Elementary School',
    type: 'Elementary',
    status: 'active',
    admin: 'Kaylah Edwards',
    adminEmail: 'kay@veryedugame.com',
    registeredUsers: 100,
    activeUsers: 10,
  },
  {
    name: 'Washington Elementary',
    type: 'Elementary',
    status: 'active',
    admin: 'Marcus Johnson',
    adminEmail: 'mjohnson@veryedugame.com',
    registeredUsers: 150,
    activeUsers: 15,
  },
  {
    name: 'Lincoln Middle School',
    type: 'Middle School',
    status: 'active',
    admin: 'Sarah Martinez',
    adminEmail: 'smartinez@veryedugame.com',
    registeredUsers: 200,
    activeUsers: 20,
  },
  {
    name: 'Roosevelt High',
    type: 'High School',
    status: 'active',
    admin: 'James Wilson',
    adminEmail: 'jwilson@veryedugame.com',
    registeredUsers: 300,
    activeUsers: 30,
  },
  {
    name: 'Oak Valley Elementary',
    type: 'Elementary',
    status: 'active',
    admin: 'Emily Chen',
    adminEmail: 'echen@veryedugame.com',
    registeredUsers: 80,
    activeUsers: 8,
  },
  {
    name: 'Riverside Middle School',
    type: 'Middle School',
    status: 'active',
    admin: 'David Thompson',
    adminEmail: 'dthompson@veryedugame.com',
    registeredUsers: 180,
    activeUsers: 18,
  },
  {
    name: 'Pine Grove Academy',
    type: 'Academy',
    status: 'active',
    admin: 'Rachel Anderson',
    adminEmail: 'randerson@veryedugame.com',
    registeredUsers: 120,
    activeUsers: 12,
  },
  {
    name: 'Sunset High School',
    type: 'High School',
    status: 'active',
    admin: 'Michael Lee',
    adminEmail: 'mlee@veryedugame.com',
    registeredUsers: 250,
    activeUsers: 25,
  },
  {
    name: 'Maple Ridge Elementary',
    type: 'Elementary',
    status: 'active',
    admin: 'Jennifer Taylor',
    adminEmail: 'jtaylor@veryedugame.com',
    registeredUsers: 90,
    activeUsers: 9,
  },
  {
    name: 'Evergreen Middle School',
    type: 'Middle School',
    status: 'active',
    admin: 'Robert Garcia',
    adminEmail: 'rgarcia@veryedugame.com',
    registeredUsers: 160,
    activeUsers: 16,
  },
  {
    name: 'Hillcrest Academy',
    type: 'Academy',
    status: 'active',
    admin: 'Patricia Wong',
    adminEmail: 'pwong@veryedugame.com',
    registeredUsers: 140,
    activeUsers: 14,
  },
  {
    name: 'Valley View High',
    type: 'High School',
    status: 'active',
    admin: 'Thomas Brown',
    adminEmail: 'tbrown@veryedugame.com',
    registeredUsers: 280,
    activeUsers: 28,
  },
  {
    name: 'Lakeside Elementary',
    type: 'Elementary',
    status: 'active',
    admin: 'Susan Miller',
    adminEmail: 'smiller@veryedugame.com',
    registeredUsers: 95,
    activeUsers: 9,
  },
  {
    name: 'Mountain View Middle',
    type: 'Middle School',
    status: 'active',
    admin: 'Kevin Zhang',
    adminEmail: 'kzhang@veryedugame.com',
    registeredUsers: 170,
    activeUsers: 17,
  },
  {
    name: 'Forest Hills High',
    type: 'High School',
    status: 'active',
    admin: 'Amanda Rodriguez',
    adminEmail: 'arodriguez@veryedugame.com',
    registeredUsers: 220,
    activeUsers: 22,
  },
];

export const info: DealInfo[] = [
  { label: 'Deal Type', value: 'Customer Pilot' },
  { label: 'Country', value: 'Brazil' },
  { label: 'Native Language', value: 'Spanish' },
  { label: 'Creation Date', value: '2024-Dec-01' },
  { label: 'Expiration Date', value: '2025-Dec-01' },
  { label: 'No. of Districts', value: 1 },
  {
    label: 'No. of Schools',
    value: 0,
    isRed: true,
    hint: 'Click here to create a school and onboard users to Hello.',
    linkText: 'here',
    linkHref: ROUTES.CREATE_ACCOUNT,
  },
  { label: 'User Limit', value: '100,000', isBold: true },
  { label: 'Registered Users', value: 0, isBold: true },
  { label: 'Licenses Remaining', value: '100,000', isBold: true },
];

export function getUniqueOptions<T>(data: T[], key: keyof T): string[] {
  const values = Array.from(new Set(data.map(item => item[key])));
  return ['All', ...values.map(String)];
}

export type Teacher = {
  id: string;
  firstName: string;
  lastName: string;
  groupsNumber: number;
  totalStudents: number;
  activeUsers: number;
  activeUserPercent: number;
  email: string;
  firstLogin?: string;
  lastLogin?: string;
};

export type Class = {
  id: string;
  name: string;
  teacher: string;
  students: number;
  activeStudents: number;
  grade: string;
  classCode?: string;
};

export type SchoolDetails = {
  id: string;
  name: string;
  dealName: string;
  district: string;
  status: 'Active' | 'Inactive';
  type: string;
  country: string;
  admin: string;
  adminEmail: string;
  adminStatus: 'Active' | 'Inactive';
  totalClasses: number;
  totalTeachers: number;
  totalStudents: number;
  history: Array<{
    id: string;
    text: string;
    date: string;
    user: string;
  }>;
  teachers: Teacher[];
  classes: Class[];
};

export const schoolDetailsData: SchoolDetails[] = [
  {
    id: 'cragmont-elementary-school',
    name: 'Cragmont Elementary School',
    dealName: 'Deal A',
    district: 'District 1',
    status: 'Active',
    type: 'Elementary',
    country: 'Brazil',
    admin: 'Kaylah Edwards',
    adminEmail: 'kay@veryedugame.com',
    adminStatus: 'Inactive',
    totalClasses: 7,
    totalTeachers: 247,
    totalStudents: 478,
    history: [
      {
        id: '1',
        text: 'Expiration date was changed from 2025-Dec-10 to 2026-Dec-01',
        date: '12/01/2024 10:20',
        user: 'Henry Sylvex',
      },
      {
        id: '2',
        text: 'The # of permitted Users was increased from 3 to 20',
        date: '12/01/2024 10:20',
        user: 'Henry Sylvex',
      },
      {
        id: '3',
        text: 'New district has been added!',
        date: '11/11/2024 10:20',
        user: 'Henry Sylvex',
      },
    ],
    teachers: [],
    classes: [
      {
        id: 'c1',
        name: 'Math 101',
        teacher: 'Nofar Helefen',
        students: 30,
        activeStudents: 15,
        grade: 'Grade 5',
      },
      {
        id: 'c2',
        name: 'Science 201',
        teacher: 'Keren Cohen',
        students: 25,
        activeStudents: 15,
        grade: 'Grade 6',
      },
      {
        id: 'c3',
        name: 'English 101',
        teacher: 'Ariel Shim',
        students: 28,
        activeStudents: 15,
        grade: 'Grade 5',
      },
      {
        id: 'c4',
        name: 'English 101',
        teacher: 'Ariel Shim',
        students: 28,
        activeStudents: 15,
        grade: 'Grade 6',
      },
      {
        id: 'c5',
        name: 'Math 102',
        teacher: 'Nofar Helefen',
        students: 30,
        activeStudents: 15,
        grade: 'Grade 5',
      },
      {
        id: 'c6',
        name: 'Science 202',
        teacher: 'Keren Cohen',
        students: 25,
        activeStudents: 15,
        grade: 'Grade 6',
      },
      {
        id: 'c7',
        name: 'English 102',
        teacher: 'Ariel Shim',
        students: 28,
        activeStudents: 15,
        grade: 'Grade 5',
      },
    ],
  },
  {
    id: 'washington-elementary',
    name: 'Washington Elementary',
    dealName: 'Deal B',
    district: 'District 2',
    status: 'Active',
    type: 'Elementary',
    country: 'Brazil',
    admin: 'Marcus Johnson',
    adminEmail: 'mjohnson@veryedugame.com',
    adminStatus: 'Active',
    totalClasses: 9,
    totalTeachers: 185,
    totalStudents: 412,
    history: [
      {
        id: '1',
        text: 'School admin changed from Sarah Lee to Marcus Johnson',
        date: '10/10/2024 09:00',
        user: 'Admin',
      },
      {
        id: '2',
        text: 'Total classes increased from 8 to 9',
        date: '09/15/2024 14:30',
        user: 'Admin',
      },
    ],
    teachers: [
      {
        id: 't3',
        firstName: 'Eve',
        lastName: 'Adams',
        groupsNumber: 1,
        totalStudents: 28,
        activeUsers: 15,
        activeUserPercent: 54,
        firstLogin: '09/15/2024 14:30',
        lastLogin: '10/10/2024 09:00',
        email: 'eve@veryedugame.com',
      },
    ],
    classes: [
      {
        id: 'c3',
        name: 'English 101',
        teacher: 'Eve Adams',
        students: 28,
        activeStudents: 15,
        grade: 'Grade 5',
      },
    ],
  },
  {
    id: 'roosevelt-high',
    name: 'Roosevelt High',
    dealName: 'Deal C',
    district: 'District 3',
    status: 'Inactive',
    type: 'High School',
    country: 'Brazil',
    admin: 'James Wilson',
    adminEmail: 'jwilson@veryedugame.com',
    adminStatus: 'Inactive',
    totalClasses: 15,
    totalTeachers: 425,
    totalStudents: 1024,
    history: [
      {
        id: '1',
        text: 'School marked as inactive',
        date: '08/01/2024 12:00',
        user: 'System',
      },
      {
        id: '2',
        text: 'Total students updated from 1000 to 1024',
        date: '07/20/2024 11:15',
        user: 'James Wilson',
      },
    ],
    teachers: [
      {
        id: 't4',
        firstName: 'Charlie',
        lastName: 'Brown',
        groupsNumber: 1,
        totalStudents: 30,
        activeUsers: 15,
        activeUserPercent: 50,
        firstLogin: '07/20/2024 11:15',
        lastLogin: '08/01/2024 12:00',
        email: 'charlie@veryedugame.com',
      },
    ],
    classes: [
      {
        id: 'c4',
        name: 'History 101',
        teacher: 'Charlie Brown',
        students: 30,
        activeStudents: 15,
        grade: 'Grade 9',
      },
    ],
  },
];

export type DistrictSchool = {
  id: string;
  name: string;
  numTeachers: number;
  numStudents: number;
  contact: string;
};

export type DistrictHistory = {
  id: string;
  text: string;
  date: string;
  user: string;
  status?: 'Active' | 'Inactive';
};

export interface DistrictDetails {
  id: string;
  name?: string;
  country?: string;
  dealName?: string;
  dealId?: string;
  manager?: string;
  email?: string;
  location?: string;
  city?: string;
  nativeLanguage?: string;
  numSchools?: number;
  registeredUsers?: number;
  creationDate?: string;
  expirationDate?: string;
  schools?: DistrictSchool[];
  history?: DistrictHistory[];
}

export const districtDetailsData: DistrictDetails[] = [
  {
    id: 'district-1',
    name: 'Region1',
    dealName: 'ACCOUNT1',
    dealId: 'account1',
    manager: 'Henry Spierer',
    email: 'henrys@melingo.com',
    location: 'Lorem',
    city: 'Ipsum',
    nativeLanguage: 'portuguese',
    numSchools: 5,
    registeredUsers: 150,
    creationDate: '2024-01-01',
    expirationDate: '2024-12-31',
    schools: [
      {
        id: 'school-11',
        name: 'California',
        numTeachers: 2,
        numStudents: 798,
        contact: 'Annette Black',
      },
    ],
    history: [
      {
        id: 'h4',
        text: 'District created',
        date: '11/15/2024 | 09:00',
        user: 'Darlene Robertson',
        status: 'Active',
      },
    ],
  },
  {
    id: 'district-2',
    name: 'Southwest Region',
    dealName: 'deal name',
    nativeLanguage: 'English',
    location: 'Los Angeles',
    numSchools: 8,
    registeredUsers: 54000,
    creationDate: '2024-Nov-15',
    expirationDate: '2025-Nov-15',
    manager: 'Darlene Robertson',
    email: 'darlene@smelingo.com',
    schools: [
      {
        id: 'school-11',
        name: 'California',
        numTeachers: 2,
        numStudents: 798,
        contact: 'Annette Black',
      },
    ],
    history: [
      {
        id: 'h4',
        text: 'District created',
        date: '11/15/2024 | 09:00',
        user: 'Darlene Robertson',
        status: 'Active',
      },
    ],
  },
];

// Demo data for HistoryPage
export const demoHistoryActions = [
  {
    type: 'deal_type_change',
    description: 'The deal type changed from "Customer pilot" to "Customer subscription"',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'expiration_date_change',
    description: 'Expiration date was changed from 2025-Dec-01 to 2026-Dec-01',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'user_limit_increase',
    description: 'The no. of permitted users was increased from 10,293 to 12,000',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'user_update',
    description: 'User John Doe was added to the system',
    timestamp: '2024-12-10T09:15:00',
    user: { name: 'Admin User', email: 'admin@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'subscription_adjustment',
    description: 'Subscription plan changed from Basic to Premium',
    timestamp: '2024-12-09T14:45:00',
    user: { name: 'Jane Smith', email: 'jane.smith@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'deal_type_change',
    description: 'The deal type changed from "Trial" to "Customer pilot"',
    timestamp: '2024-12-08T11:30:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'expiration_date_change',
    description: 'Expiration date was changed from 2024-Dec-01 to 2025-Dec-01',
    timestamp: '2024-12-07T16:00:00',
    user: { name: 'Jane Smith', email: 'jane.smith@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'user_limit_increase',
    description: 'The no. of permitted users was increased from 5,000 to 10,293',
    timestamp: '2024-12-06T13:20:00',
    user: { name: 'Admin User', email: 'admin@company.com' },
    dealName: '473HO081',
  },
  {
    type: 'deal_type_change',
    description: 'The deal type changed from "Customer pilot" to "Customer subscription"',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'expiration_date_change',
    description: 'Expiration date was changed from 2025-Dec-01 to 2026-Dec-01',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'user_limit_increase',
    description: 'The no. of permitted users was increased from 10,293 to 12,000',
    timestamp: '2024-12-11T10:20:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'user_update',
    description: 'User John Doe was added to the system',
    timestamp: '2024-12-10T09:15:00',
    user: { name: 'Admin User', email: 'admin@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'subscription_adjustment',
    description: 'Subscription plan changed from Basic to Premium',
    timestamp: '2024-12-09T14:45:00',
    user: { name: 'Jane Smith', email: 'jane.smith@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'deal_type_change',
    description: 'The deal type changed from "Trial" to "Customer pilot"',
    timestamp: '2024-12-08T11:30:00',
    user: { name: 'Nofar Halpern', email: 'Nofarh@melingo.com' },
    dealName: '473HO081',
  },
  {
    type: 'expiration_date_change',
    description: 'Expiration date was changed from 2024-Dec-01 to 2025-Dec-01',
    timestamp: '2024-12-07T16:00:00',
    user: { name: 'Jane Smith', email: 'jane.smith@company.com' },
    dealName: '582JK092',
  },
  {
    type: 'user_limit_increase',
    description: 'The no. of permitted users was increased from 5,000 to 10,293',
    timestamp: '2024-12-06T13:20:00',
    user: { name: 'Admin User', email: 'admin@company.com' },
    dealName: '473HO081',
  },
];
